module.exports = __webpack_public_path__ + "static/media/2006.b36089b8.png";